export const STAR_ICON = "portal/m/Twid_icon.png";

export const DEFAULT_STRIP_A11Y_ACTION = "open payment options";

export const ANIMATION_DURATION = 500; // 0.5 seconds per transition
export const DISPLAY_DURATION = 1500; // 1.5 second to display each message
export const STRIP_STAR_ICON_WIDTH = 16;
export const STRIP_STAR_ICON_HEIGHT = 16;
export const STRIP_START_CLOUDINARY_HEIGHT = 2 * STRIP_STAR_ICON_HEIGHT;
export const STRIP_START_CLOUDINARY_WIDTH = 2 * STRIP_STAR_ICON_WIDTH;
export const SPLIT_PAY_ICON_WIDTH = 25;
export const SPLIT_PAY_ICON_HEIGHT = 25;
export const SPLIT_PAY_ICON_CLOUDINARY_HEIGHT = 2 * SPLIT_PAY_ICON_HEIGHT;
export const SPLIT_PAY_ICON_CLOUDINARY_WIDTH = 2 * SPLIT_PAY_ICON_WIDTH;

export const STRIP_DIMENSIONS = {
    width: String(STRIP_STAR_ICON_WIDTH),
    height: String(STRIP_STAR_ICON_HEIGHT),
    cloudinaryHeight: STRIP_START_CLOUDINARY_HEIGHT,
    cloudinaryWidth: STRIP_START_CLOUDINARY_WIDTH,
};

export const SPLIT_PAY_ICON_DIMENSIONS = {
    width: String(SPLIT_PAY_ICON_WIDTH),
    height: String(SPLIT_PAY_ICON_HEIGHT),
    cloudinaryHeight: SPLIT_PAY_ICON_CLOUDINARY_HEIGHT,
    cloudinaryWidth: SPLIT_PAY_ICON_CLOUDINARY_WIDTH,
};
